module.exports = __webpack_public_path__ + "media/images/canvas-logo-b3233d41.png";